/* Sapone Di Toscana — staffel (1 / 3 / 10 flessen) klikbaar: het aantal gaat direct in de winkelmand. */
(function () {
  'use strict';
  var doc = document;
  var QTY = [1, 3, 10];
  /* Teksten komen uit de locale-bestanden (window.sdtStrings, zie layout/theme.liquid); Nederlands is de terugvaloptie. */
  function S(key, fallback) { var o = window.sdtStrings; return o && typeof o[key] === 'string' ? o[key] : fallback; }
  function fmt(str, map) { return str.replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }

  function enhance() {
    doc.querySelectorAll('.sdt-staffel').forEach(function (box) {
      if (box.dataset.luxTiers === 'on') return;
      var form = doc.querySelector('product-form form[action*="/cart/add"]');
      var submit = form ? form.querySelector('[type=submit]') : null;
      if (!form || !submit) return;
      box.dataset.luxTiers = 'on';
      box.setAttribute('data-lux-quick', '');
      var titleEl = doc.querySelector('.product__title h1');
      var naam = titleEl ? titleEl.textContent.trim() : '';
      box.querySelectorAll('.sdt-staffel__list > li').forEach(function (li, i) {
        if (li.querySelector('.sdt-staffel__btn')) return;
        var n = li.querySelector('.sdt-staffel__n');
        var q = parseInt(li.getAttribute('data-qty') || (n ? n.textContent : ''), 10) || QTY[i] || 1;
        var btn = doc.createElement('button');
        btn.type = 'button';
        btn.className = 'sdt-staffel__btn';
        btn.dataset.luxTier = q;
        btn.dataset.loading = S('loading', 'Toevoegen…');
        btn.dataset.added = S('addedCheck', 'Toegevoegd ✓');
        btn.setAttribute('aria-label', fmt(S('tierAria', 'Voeg [quantity][product] toe aan je winkelmand'), {
          quantity: n ? n.textContent.trim() : fmt(S('tierPieces', '[count] stuks'), { count: q }),
          product: naam ? ' ' + naam : ''
        }));
        while (li.firstChild) btn.appendChild(li.firstChild);
        var cta = doc.createElement('span');
        cta.className = 'sdt-staffel__cta';
        cta.setAttribute('aria-hidden', 'true');
        var ctaLabel = doc.createElement('span');
        ctaLabel.setAttribute('data-label', '');
        ctaLabel.textContent = S('tierCta', '+ Toevoegen');
        cta.appendChild(ctaLabel);
        btn.appendChild(cta);
        li.appendChild(btn);
      });
      var head = box.querySelector('.sdt-staffel__head');
      if (head && !head.dataset.luxTip) {
        head.dataset.luxTip = '1';
        head.insertAdjacentText('beforeend', ' ' + S('tierTip', 'Klik op een aantal en het gaat direct in je winkelmand.'));
      }
      if (!box.querySelector('[data-quick-error]')) box.insertAdjacentHTML('beforeend', '<p class="sdt-staffel__error" data-quick-error role="alert" hidden></p>');
      var sync = function () {
        var off = !!submit.disabled;
        box.querySelectorAll('.sdt-staffel__btn').forEach(function (b) { b.disabled = off; });
      };
      new MutationObserver(sync).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
      sync();
    });
  }

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-tier]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var box = btn.closest('[data-lux-quick]');
    var err = box ? box.querySelector('[data-quick-error]') : null;
    if (err) { err.hidden = true; err.textContent = ''; }
    var field = doc.querySelector('product-form form[action*="/cart/add"] [name="id"]');
    var variant = (field && field.value) || btn.dataset.variant;
    if (!variant) return;
    var qty = parseInt(btn.dataset.luxTier, 10) || 1;
    if (window.SDTLux && typeof window.SDTLux.addToCart === 'function') {
      window.SDTLux.addToCart(variant, qty, btn);
    } else {
      window.location = '/cart/add?id=' + encodeURIComponent(variant) + '&quantity=' + qty;
    }
  });

  /* Video's: pauzeknop en 'minder beweging' respecteren */
  function setVideo(btn, play) {
    var v = btn.parentNode.querySelector('video');
    if (!v) return;
    if (play) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
    btn.setAttribute('aria-pressed', play ? 'false' : 'true');
    var l = btn.querySelector('[data-label]'); if (l) l.textContent = play ? S('videoPause', 'Video pauzeren') : S('videoPlay', 'Video afspelen');
  }
  function initVideos() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    doc.querySelectorAll('[data-lux-video-toggle]').forEach(function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      var v = btn.parentNode.querySelector('video');
      if (v) { v.muted = true; v.setAttribute('playsinline', ''); }
      if (reduce) setVideo(btn, false);
    });
  }
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-video-toggle]');
    if (!btn) return;
    setVideo(btn, btn.getAttribute('aria-pressed') === 'true');
  });

  function boot() { enhance(); initVideos(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  doc.addEventListener('shopify:section:load', boot);
})();
